var setInitialRecaptcha = (recaptchaSiteKey) => {
    var promise = new Promise((resolve, reject) => {
        try {
            var id = 'recaptchaRegister';

            var placeholderForRecaptcha = document.getElementById(id);
            if (placeholderForRecaptcha && grecaptcha) {
                grecaptcha.ready(function () {
                    var id = 'recaptchaRegister';
                    var action =
                        document
                            .getElementById(id)
                            .getAttribute('data-action') ||
                        'action-not-defined';
                    grecaptcha
                        .execute(recaptchaSiteKey, {
                            action: action,
                        })
                        .then(function (token) {
                            resolve(token);
                        })
                        .catch((err) => {
                            console.error('Error in recaptcha management', err);
                            reject('Error in recaptcha management');
                        });
                });
            }
        } catch (error) {
            reject(error);
        }
    });
    return promise;
};

export { setInitialRecaptcha };
